<script setup>
const props = defineProps({
    variant: {
        type: String,
        required: true,
        validator: (value) => ['green', 'red', 'navy', 'purple', 'gray', 'both'].includes(value)
    },
    dot: {
        type: Boolean,
        default: false
    }
});

const variantClasses = {
    green: 'bg-[#dcf5d4] text-[#2d6b1a]',
    red: 'bg-[#fde8e7] text-[#a83430]',
    navy: 'bg-[#e7edf4] text-[#375475]',
    purple: 'bg-[#ede9fe] text-[#5b21b6]',
    gray: 'bg-[#EDE8DF] text-[#64748b]',
    both: 'bg-[#f0f4f8] text-[#375475] border border-[#d0dcea]',
};
</script>

<template>
<span class="foodflow-badge" :class="variantClasses[props.variant]">
    <span v-if="dot" class="foodflow-badge-dot" :class="variant === 'red' ? 'bg-[#F06660]' : 'bg-[#61B245]'" />
    <slot />
</span>
</template>
